import React, { useState } from "react";
import "./Navbar.css";

import logo from "../../../image/favicon-logo.webp";
import WaitlistButton from "../waitlist/WaitlistButton";
import { landing_status } from "../constants/Constants_Var";
import { Link } from "react-router-dom";
import WaitListForm from "../waitlistform/WaitListForm";

const Navbar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div className="lp-logo-section">
        <div className="lp-logo">
          <Link to="/landing">
            {" "}
            <img
              src={logo}
              alt="newslettrai-logo | Newslettrai"
              style={{ width: "40px" }}
            />
          </Link>
          <Link to="/landing">
            <h1
              style={{
                color: "#0074D9",
                fontFamily: "Dela Gothic One",
                fontWeight: "400",
              }}
            >
              newslett
              <span style={{ color: "#FFC700", fontFamily: "Dela Gothic One" }}>
                r
              </span>{" "}
              AI{" "}
            </h1>
          </Link>
        </div>

        <div className="landing-waitlist-btn-display">
          <WaitlistButton
            waitlist={openModal}
            waitlistbtn_text={"Join Waitlist"}
          />
          <WaitListForm
            isOpen={isModalOpen}
            onClose={closeModal}
            name={"inputwaitlist1"}
            status={landing_status.waitlist}
          />
        </div>
      </div>
    </>
  );
};

export default Navbar;
